module.exports = __webpack_public_path__ + "b52d551c273917474445024716176f0d.pdf";